import { Component, OnInit, Input } from '@angular/core';
import { ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../../services/data.service';
import { AppComponentGenericComponent } from '../../../custom/app-component-generic/app-component-generic.component';

import { GenericExternalCommandType } from '../../../../models/generic-external-command';
import { StatisticheGeneraleDettaglioTableField } from '../../../../models/library-table-field';
import { rendicontazioneDettaglioType } from '../../../../models/rendicontazione';

@Component({
  selector: 'app-rendicontazione-dettaglio',
  templateUrl: './rendicontazione-dettaglio.component.html',
  styleUrls: ['./rendicontazione-dettaglio.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RendicontazioneDettaglioComponent extends AppComponentGenericComponent implements OnInit {
    @Input() data: any;

    // Sync
    emissioniSync: Subscription;
    emissioni: any[] = [];
    emissioniLocal: any[] = [];

    pagamenti: any[];
    rendicontazioniDettaglioMap: Map<string, rendicontazioneDettaglioType> = new Map();
    rendicontazioniDettaglioFiltered: rendicontazioneDettaglioType[] = [];
    rendicontazioniDettaglioFilteredSubmit: any[] = [];
    rendicontazioneDettaglioTotal: rendicontazioneDettaglioType;


    // FilterBox
    externCommands: Map<string, GenericExternalCommandType> = null;

    // Table
    tableFields: StatisticheGeneraleDettaglioTableField;
    pagamentiFiltered: any[];
    ngClassRow = "\"\""

    constructor(private cdr: ChangeDetectorRef, protected dataService: DataService) {
	super(dataService, 'statistiche-rendicontazione');
    }

    ngOnInit() {
	this.externCommands = new Map();
	this.parametri.setTypeFilter("rendicontazione-dettaglio");
	this.parametri.setTitleBox("Rendicontazione Dettaglio");
	this.parametri.setNumFilteredTxt("Righe");
	this.parametri.setWritePermission(this.checkPermission('rendicontazione-dettaglio','write'));
	this.parametri.setExternCommands(this.externCommands);
	this.updateParametri();

	this.rendicontazioniDettaglioFiltered = [];
	this.rendicontazioniDettaglioFilteredSubmit = [];
	this.emissioniSync = this.dataService.emissioni$.subscribe(
	    emissioni => {
		console.log('RENDICONTAZIONE-DETAIL', emissioni);
		this.parametri.setEmissioni(emissioni);
		this.updateParametri();
		this.compilaRendicontazione();
	    });
    }

    ngOnChanges(changes: any){
	console.log('CHANGE RENDICONTAZIONE-DETAIL-BOX', changes);
	if(changes.data){
	    console.log('CHANGE RENDICONTAZIONE-DETAIL DATA', changes);
	    if(this.data.pagamenti){
		//this.pagamenti = this.data.pagamenti;
		this.parametri.setDataArraySource(this.data.pagamenti);
		this.updateParametri();
		this.compilaRendicontazione();
	    }
	}
	if(changes.pagamentiFiltered){
	    console.log('CHANGE RENDICONTAZIONE-DETAIL PAGAMENTI-FILTERED', changes);
	    this.compilaRendicontazione();
	}
	if(changes.parametri){
	    this.updateParametri();
	}
    }

    updateParametri(){
	//console.log('CHANGE RENDICONTAZIONE-GENERALE-BOX UPDATEPARAMETRI', this.parametri);
	this.parametriString = this.parametri.generateParametriToString();
	this.cdr.markForCheck();
	//console.log('CHANGE RENDICONTAZIONE-GENERALE-BOX UPDATEPARAMETRISTRING', this.parametriString);
    }

    findEmissione(element: any){
        //console.log("emissioniLocal findEmissione", element, this);
        return element.id == this;
    }

    riempiEmissioneLocal(praticaObject: any){
	//cerco emissione se già esiste
	if(praticaObject && praticaObject["pratica"]){
	    let emissioneTrovata = this.emissioni.find(this.findEmissione, praticaObject["pratica"]['emissione_id']);
	    if(emissioneTrovata){
		let trovato = this.emissioniLocal.find(this.findEmissione, emissioneTrovata['id']);
		if(trovato){
		    //console.log("trovato", emissioneTrovata);
		}else{
		    //console.log("non trovato", emissioneTrovata);
		    this.emissioniLocal.push(emissioneTrovata);
		}
	    }
	}
    }

    checkEsisteRendicontazioneMap(anagrafica_id: any, rendicontazioneDettaglio: rendicontazioneDettaglioType){
	//console.log("rendicontazioneDettaglio aggregaRendicondazioneMap '", anagrafica_id, "'", this.rendicontazioniDettaglioMap);

	if(this.rendicontazioniDettaglioMap.has(anagrafica_id)){
	    //console.log("rendicontazione si anagrafica_id");
	}else{
	    //console.log("rendicontazione no anagrafica_id");
	    rendicontazioneDettaglio.setFieldValue("anagrafica_id", anagrafica_id);
	    //console.log("rendicontazioneDettaglio", rendicontazioneDettaglio);
	    this.rendicontazioniDettaglioMap.set(anagrafica_id, rendicontazioneDettaglio);
	}
    }

    aggregaRendicondazioneMap(pagamento: any, praticaObject: any, groupByType: any = null){
	console.log("rendicontazioneDettaglio", "pagamento", pagamento, "praticaObject", praticaObject);
	if(praticaObject && praticaObject["pratica"]){
	    let anagrafica_id = praticaObject["pratica"]['anagrafica_id'];
	    //console.log("rendicontazioneDettaglio aggregaRendicondazioneMap '", anagrafica_id, "'");
	    let rendicontazioneDettaglio = new rendicontazioneDettaglioType(this.dataService.getCommon().getLocale());

	    //console.log("anagrafica_id", anagrafica_id);
	    this.checkEsisteRendicontazioneMap(anagrafica_id, rendicontazioneDettaglio);
	    //console.log("rendicontazioniDettaglioMap", this.rendicontazioniDettaglioMap);
	    let singleRendicontazione = this.rendicontazioniDettaglioMap.get(anagrafica_id);
	    console.log("singleRendicontazione", singleRendicontazione, pagamento);

	    let nominativo = "";
	    if(pagamento.cognome){
		nominativo = pagamento.cognome;
	    }
	    if(pagamento.nome){
		nominativo = nominativo + ' ';
		nominativo = nominativo + pagamento.nome;
	    }
	    singleRendicontazione.setFieldValue("nominativo", nominativo);
	    singleRendicontazione.setFieldValue("emissione", pagamento.emissione);
	    singleRendicontazione.setFieldValue("canale", pagamento.canale);
	    singleRendicontazione.setFieldValue("anno", 2018);
	    singleRendicontazione.setFieldValue("accreditoData", pagamento.dataAccredito);
	    singleRendicontazione.setFieldValue("rifRata", pagamento.rifRata);
	    let pagatoTemp = Number(singleRendicontazione.getFieldValue("pagato"));
	    singleRendicontazione.setFieldValue("pagato", pagatoTemp + parseFloat(pagamento.sommaPagata));

	    if(praticaObject && praticaObject["pratica"] && praticaObject["dettagli"]){
		let pratica = praticaObject["pratica"];
		let dettagli = praticaObject["dettagli"];
		let local_totale = pratica["totale_dovuto"];
		let local_pagato = Number(singleRendicontazione.getFieldValue("pagato"));
		let local_dovuto = 0.00;
		let local_aggio = 0.00;
		let local_oneri = 0.00;
		let local_altro = 0.00;
		let local_arr = 0.00;
		let local_notifica_spese = parseFloat(pratica["notifica_spese_agg"]) + parseFloat(pratica["notifica_spese_agg_prec"]);
		if(local_notifica_spese <= local_pagato){
		    local_notifica_spese = local_notifica_spese;
		}else{
		    local_notifica_spese = local_pagato;
		}
		local_altro += parseFloat(pratica["spese_esecutive"]) + parseFloat(pratica["spese_giudiziali"]);
		local_altro += parseFloat(pratica["diritti_pf_agg"]) + parseFloat(pratica["diritti_pf_agg_prec"]);
		//console.log("rendicontazione local_totale", local_totale);
		local_totale -= local_notifica_spese;
		local_pagato -= local_notifica_spese;

		dettagli.forEach((value: any, key: any) => {
		    local_dovuto += parseFloat(value["dovuto"]) - parseFloat(value["versato"] + parseFloat(value["arrotondamento"]));
		    local_oneri += parseFloat(value["oneri_risc_attuali"]);
		    local_altro += parseFloat(value["sanzioni"]) + parseFloat(value["interessi"]) + parseFloat(value["notifica_spese"]);
		    local_altro += parseFloat(value["sanzioni_agg"]) + parseFloat(value["sanzioni_agg_prec"]);
		    local_altro += parseFloat(value["interessi_agg"]) + parseFloat(value["interessi_agg_prec"]);
		});
		local_dovuto = (local_dovuto * local_pagato) / local_totale;
		local_oneri = (local_oneri * local_pagato) / local_totale;
		local_altro = (local_altro * local_pagato) / local_totale;
		local_aggio = (local_pagato - local_notifica_spese - local_oneri)*0.33;
		local_arr = parseFloat(local_pagato.toFixed(2)) - (parseFloat(local_dovuto.toFixed(2)) + parseFloat(local_oneri.toFixed(2)) + parseFloat(local_altro.toFixed(2)));
		local_dovuto += local_arr;

		singleRendicontazione.setFieldValue("debito", local_dovuto);
		singleRendicontazione.setFieldValue("notificaSpese", local_notifica_spese);
		singleRendicontazione.setFieldValue("oneri", local_oneri);
		singleRendicontazione.setFieldValue("altro",local_altro);
		singleRendicontazione.setFieldValue("aggio", local_aggio);
	    }
	}
    }

    compilaRendicontazione(groupByType: any = null){
	this.rendicontazioniDettaglioFiltered = [];
	this.rendicontazioniDettaglioFilteredSubmit = [];
	this.rendicontazioniDettaglioMap.clear();
	if(this.pagamentiFiltered){
	    for(let pagamento of this.pagamentiFiltered){
		let praticaObject = {};
		this.dataService.getPraticaById(pagamento["uid"], (localPratica) => {
		    praticaObject["pratica"] = localPratica;
		});
		this.dataService.getDettagliByUid(pagamento["uid"], (localDettagli) => {
		    praticaObject["dettagli"] = localDettagli;
		});
		this.riempiEmissioneLocal(praticaObject);
		this.aggregaRendicondazioneMap(pagamento, praticaObject, groupByType);
	    }
	    this.parametri["emissioni"] = this.emissioniLocal;
	    this.updateParametri();
	}
	console.log("rendicontazioniMap rendicontazioniDettaglioMap", this.rendicontazioniDettaglioMap);
	this.rendicontazioniDettaglioMap.forEach((value: rendicontazioneDettaglioType, key: string) => {
	    console.log("rendicontazioniDettaglioMap", key, value);
	    let rendicontazione = new rendicontazioneDettaglioType(this.dataService.getCommon().getLocale());
	    rendicontazione.setFieldValue("anagrafica_id", value.getFieldValue("anagrafica_id"));
	    rendicontazione.setFieldValue("nominativo", value.getFieldValue("nominativo"));
	    rendicontazione.setFieldValue("emissione", value.getFieldValue("emissione"));
	    rendicontazione.setFieldValue("canale", value.getFieldValue("canale"));
	    rendicontazione.setFieldValue("anno", value.getFieldValue("anno"));
	    rendicontazione.setFieldValue("pagato", value.getFieldValue("pagato"));
	    rendicontazione.setFieldValue("debito", value.getFieldValue("debito"));
	    rendicontazione.setFieldValue("sanzioni", value.getFieldValue("sanzioni"));
	    rendicontazione.setFieldValue("interessi", value.getFieldValue("interessi"));
	    rendicontazione.setFieldValue("notificaSpese", value.getFieldValue("notificaSpese"));
	    rendicontazione.setFieldValue("arrotondamento", value.getFieldValue("arrotondamento"));

	    rendicontazione.setFieldValue("interessiAgg", value.getFieldValue("interessiAgg"));
	    rendicontazione.setFieldValue("oneriAgg", value.getFieldValue("oneriAgg"));
	    rendicontazione.setFieldValue("notificaSpeseAgg", value.getFieldValue("notificaSpeseAgg"));
	    rendicontazione.setFieldValue("esecutiveSpese", value.getFieldValue("esecutiveSpese"));
	    rendicontazione.setFieldValue("giudizialiSpese", value.getFieldValue("giudizialiSpese"));
	    rendicontazione.setFieldValue("accreditoData", value.getFieldValue("accreditoData"));
	    rendicontazione.setFieldValue("rifRata", value.getFieldValue("rifRata"));
	    //console.log("rendicontazioneGenerale rendicontazione", rendicontazione);
	    this.rendicontazioniDettaglioFiltered.push(rendicontazione);

	    let rendicontazioneSubmit = {};
	    rendicontazioneSubmit["anagrafica_id"] = value.getFieldString("anagrafica_id");
	    rendicontazioneSubmit["nominativo"] = value.getFieldString("nominativo");
	    rendicontazioneSubmit["emissione"] = value.getFieldString("emissione");
	    rendicontazioneSubmit["canale"] = value.getFieldString("canale");
	    rendicontazioneSubmit["anno"] = value.getFieldString("anno");
	    rendicontazioneSubmit["pagato"] = value.getFieldString("pagato");
	    rendicontazioneSubmit["debito"] = value.getFieldString("debito");
	    rendicontazioneSubmit["sanzioni"] = value.getFieldString("sanzioni");
	    rendicontazioneSubmit["interessi"] = value.getFieldString("interessi");
	    rendicontazioneSubmit["notificaSpese"] = value.getFieldString("notificaSpese");
	    rendicontazioneSubmit["arrotondamento"] = value.getFieldString("arrotondamento");
	    rendicontazioneSubmit["interessiAgg"] = value.getFieldString("interessiAgg");
	    rendicontazioneSubmit["oneriAgg"] = value.getFieldString("oneriAgg");
	    rendicontazioneSubmit["notificaSpeseAgg"] = value.getFieldString("notificaSpeseAgg");
	    rendicontazioneSubmit["esecutiveSpese"] = value.getFieldString("esecutiveSpese");
	    rendicontazioneSubmit["giudizialiSpese"] = value.getFieldString("giudizialiSpese");
	    rendicontazioneSubmit["accreditoData"] = value.getFieldString("accreditoData");
	    rendicontazioneSubmit["rifRata"] = value.getFieldString("rifRata");
	    //console.log("rendicontazioneGenerale rendicontazioneSubmit", rendicontazioneSubmit);
	    this.rendicontazioniDettaglioFilteredSubmit.push(rendicontazioneSubmit);
	});
	//console.log("rendicontazioneDettaglio filtered", this.rendicontazioniDettaglioFiltered);
	this.riempiRendicontazioneTotal(this.rendicontazioniDettaglioFiltered);
    }

    riempiRendicontazioneTotal(rendicontazioneDettagli: rendicontazioneDettaglioType[]){
	this.rendicontazioneDettaglioTotal = new rendicontazioneDettaglioType(this.dataService.getCommon().getLocale());
	//console.log("rendicontazioneDettagli pre", this.rendicontazioneDettaglioTotal);

	this.rendicontazioneDettaglioTotal.getMap().forEach((value, key, map) => {
	    this.rendicontazioneDettaglioTotal.clearField(key);
	    let headerFieldType = this.rendicontazioneDettaglioTotal.getFieldType(key);
	    if(headerFieldType == 'number' || headerFieldType == 'currency'){
		let totalValue  = rendicontazioneDettagli.reduce(
		    (prevVal, elem) => {
			let actVal = Number(elem.getFieldValue(key));
			//console.log("rendicontazioneDettagli reduce", prevVal, typeof(prevVal), "---!", actVal , "!---", typeof(actVal));
			return prevVal + actVal;
		    }, 0.00
		);
		this.rendicontazioneDettaglioTotal.setFieldValue(key, totalValue);
	    }
	});
	//console.log("rendicontazioneDettagli post", this.rendicontazioneDettaglioTotal);
	this.generateFooterRow();
    }

    generateFooterRow(){
	this.footerFields = [];
	let totalField: any;
	for(let headerField of this.headerFields){
	    totalField = {};
	    totalField["code"] = headerField["code"];
	    totalField["class"] = headerField["class"];
	    totalField["value"] = this.rendicontazioneDettaglioTotal.getFieldString(headerField["code"]);
	    this.footerFields.push(totalField);
	}
	console.log("totalFields", this.footerFields);
    }

    manageEventFilterBox($event){
	console.log("manageEventFilterBox", $event);
	if($event){
	    switch($event.type){
		case 'filterResult':
		    this.pagamentiFiltered = $event.data;
		    this.compilaRendicontazione();
		    console.log("rendicontazioniDettaglioFiltered", $event.data);
		    break;
		case 'groupBy':
		    let groupByType = $event.data;
		    this.compilaRendicontazione(groupByType);
		    console.log("groupByType", groupByType, this.rendicontazioniDettaglioFiltered);
		    break;
		default:

	    }
	}
    }

    sendData(){
    }

    newItem(){
    }

    ngOnDestroy() {
	this.emissioniSync.unsubscribe();
    }
}
